export default __webpack_public_path__ + "static/media/logocuadrado.24c5a357.jpg";